export interface DebugStats {
  clientTick: number; serverTick: number; snapTick: number; seq: number
  rtt: number; offset: number; predErr: number; snapshotAgeMs: number; interpDepth: number
  state: string; stamina: number; shieldAge: number; hitstop: boolean; fps: number
  pendingInputs: number; corrections: number; hardResyncs: number; bytesIn: number
  room: string; team: string; players: number; discs: number; phase: string; aim: string; device: string
  fx?: string
}

export class DebugOverlay {
  visible: boolean
  constructor(private readonly el: HTMLElement, visible: boolean) { this.visible = visible; el.style.display = visible ? '' : 'none' }
  toggle(): void { this.visible = !this.visible; this.el.style.display = this.visible ? '' : 'none' }
  render(s: DebugStats): void {
    if (!this.visible) return
    this.el.textContent = [
      `room ${s.room} team ${s.team} phase ${s.phase} players ${s.players} discs ${s.discs}`,
      `tick client ${s.clientTick} server~${s.serverTick} snap ${s.snapTick} (${s.snapTick % 2 === 0 ? 'even' : 'ODD'}) ahead ${s.clientTick - s.snapTick}`,
      `seq ${s.seq} pending ${s.pendingInputs} rtt ${s.rtt.toFixed(0)}ms offset ${s.offset.toFixed(0)}ms fps ${s.fps.toFixed(0)}`,
      `pred err ${s.predErr.toFixed(3)}m corrections ${s.corrections} hard ${s.hardResyncs}`,
      `snap age ${s.snapshotAgeMs.toFixed(0)}ms interp depth ${s.interpDepth} in ${(s.bytesIn / 1024).toFixed(0)}KB`,
      `state ${s.state} stamina ${s.stamina.toFixed(0)} shieldAge ${s.shieldAge} hitstop ${s.hitstop ? 'ON' : 'off'}`,
      `aim ${s.aim} device ${s.device}`,
      ...(s.fx ? [s.fx] : []),
      `WASD move | mouse aim | LMB/Space throw | RMB/E shield | Shift/F dash | Tab queue | Q spectate | F8 camera`,
    ].join('\n')
  }
}
